module.exports = __webpack_public_path__ + "static/media/icon-arrow--up-med-gray.bdd0b103.svg";


//////////////////
// WEBPACK FOOTER
// ./src/shared/imgs/icon-arrow--up-med-gray.svg
// module id = 286
// module chunks = 0